import { render, staticRenderFns } from "./NoteDialog.vue?vue&type=template&id=08eddf3e&"
import script from "./NoteDialog.vue?vue&type=script&lang=js&"
export * from "./NoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NoteDialog.vue"
export default component.exports